import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Toaster } from "sonner";
import "@/App.css";
import { useLenis } from "@/hooks/useLenis";
import { ASSETS } from "@/lib/siteData";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { About } from "@/components/site/About";
import { Services } from "@/components/site/Services";
import { Jurisdiction } from "@/components/site/Jurisdiction";
import { Ethos } from "@/components/site/Ethos";
import { Resources } from "@/components/site/Resources";
import { Consult } from "@/components/site/Consult";
import { Footer } from "@/components/site/Footer";

const Preloader = () => (
  <motion.div
    data-testid="preloader"
    initial={{ opacity: 1 }}
    exit={{ y: "-100%" }}
    transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1], delay: 0.2 }}
    className="fixed inset-0 z-[100] bg-[#060606] flex items-center justify-center"
  >
    <div className="flex flex-col items-center">
      <motion.div
        initial={{ opacity: 0, scale: 0.85 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      >
        <img src={ASSETS.logo} alt="Advocate" className="h-16 md:h-20 w-auto object-contain" />
      </motion.div>
      <div className="overflow-hidden mt-4">
        <motion.p
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: 0.3 }}
          className="font-serif-display italic text-xl md:text-2xl text-[var(--off)]/80"
        >
          Adv. Sanjay Kr Sinha
        </motion.p>
      </div>
      <motion.div
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: 1, ease: "easeInOut", delay: 0.4 }}
        className="mt-6 h-px w-40 bg-[var(--off)]/40 origin-left"
      />
    </div>
  </motion.div>
);

function App() {
  const skipIntro = typeof window !== "undefined" && window.location.search.includes("nointro");
  const [loaded, setLoaded] = useState(skipIntro);
  useLenis();

  useEffect(() => {
    if (skipIntro) return;
    const t = setTimeout(() => setLoaded(true), 1500);
    document.body.style.overflow = "hidden";
    return () => clearTimeout(t);
  }, [skipIntro]);

  useEffect(() => {
    if (loaded) document.body.style.overflow = "";
  }, [loaded]);

  return (
    <div className="App grain">
      <Toaster theme="dark" position="bottom-right" />
      <AnimatePresence>{!loaded && <Preloader />}</AnimatePresence>
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Services />
        <Jurisdiction />
        <Ethos />
        <Resources />
        <Consult />
      </main>
      <Footer />
    </div>
  );
}

export default App;
